import { render } from "./memberRecord.vue?vue&type=template&id=40dbf688&scoped=true"
import script from "./memberRecord.vue?vue&type=script&lang=js"
export * from "./memberRecord.vue?vue&type=script&lang=js"

import "./memberRecord.vue?vue&type=style&index=0&id=40dbf688&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dbf688"]])

export default __exports__